import { mediaQuery } from 'modules/utils';
import { setIconColor } from 'modules/utils/cssUtils';
import styled from 'styled-components';
import { theme } from '../theme';
import { ToggleButtonType } from './ToggleButtonType';

export const checkDisplay = (props: {
  desktopOnly?: boolean;
  mobileOnly?: boolean;
}) => {
  if (props.desktopOnly) {
    return `
      display: none;
          
      ${mediaQuery('md')} {
        display: flex;
      }
    `;
  }
  if (props.mobileOnly) {
    return `
      display: flex;
          
      ${mediaQuery('md')} {
        display: none;
      }
    `;
  }
  return ``;
};

interface StyledToggleButtonProps {
  buttonType?: ToggleButtonType;
  disabled?: boolean;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
  color?: string;
  toggled?: boolean;
  className?: string;
  noMobileText?: boolean;
}

export const StyledToggleButton = styled.button<StyledToggleButtonProps>`
  display: flex;

  ${(props) => checkDisplay(props)}

  text-decoration: var(--text-underline);
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  padding: 0;

  cursor: pointer;

  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  flex-direction: ${(props) =>
    props.buttonType === ToggleButtonType.Horizontal ? 'row' : 'column'};

  ${(props) => {
    if (props.disabled) {
      return `
        color: ${props.theme.colors.primaryK3};

        ${StyledIconContainer} {
          ${setIconColor(props.theme.colors.primaryK3)}
        }
      `;
    }
    if (props.toggled) {
      return `
        color: ${props.theme.colors.primaryT2};

        ${StyledIconContainer} {
          ${setIconColor(props.theme.colors.primaryT2)}
        }
        
        ${
          props.buttonType === ToggleButtonType.Text &&
          `
            ${StyledTextContainer} {
              border-bottom: 0.2rem solid ${props.theme.colors.primaryT2};
            }
          `
        }}
        
        &:hover {
          color: ${props.theme.colors.primaryT1};

          ${StyledIconContainer} {
            ${setIconColor(props.theme.colors.primaryT1)}
          }

          ${
            props.buttonType === ToggleButtonType.Text &&
            `
              ${StyledTextContainer} {
                border-bottom: 0.2rem solid ${props.theme.colors.primaryT1};
              }
            `
          }}
        }
      `;
    }
    return `
      color: ${props.color ? props.color : props.theme.colors.primaryK10};

      ${StyledIconContainer} {
        ${setIconColor(props.color ? props.color : props.theme.colors.primaryK10)}
      }

      &:hover {
        color: ${props.theme.colors.primaryK7};

        ${StyledIconContainer} {
          ${setIconColor(props.theme.colors.primaryK7)}
        }
      }
    `;
  }}
`;

export const StyledIconContainer = styled.div<StyledToggleButtonProps>`
  ${(props) => {
    if (props.buttonType === ToggleButtonType.Icon) {
      return `
        height: 100%;
        width: 100%;
        max-height: 1.5rem;
        max-width: 1.5rem;
      `;
    }

    return `
      height: 1.5rem;
      width: 1.5rem;
    `;
  }}

  display: flex;
  align-items: center;
  justify-items: center;

  position: relative;

  margin-bottom: 0.4rem;

  ${mediaQuery('md')} {
    margin-bottom: 0.2rem;
  }

  margin-right: ${(props) =>
    props.buttonType === ToggleButtonType.Horizontal ? '0.4rem' : '0'};

  * {
    height: 100%;
    width: 100%;
  }
`;

export const StyledTextContainer = styled.div<StyledToggleButtonProps>`
  text-transform: uppercase;
  font-size: var(--h5-font-size);
  font-weight: ${theme.fontWeight.bold};
  word-spacing: var(--word-spacing);

  ${(props) =>
    props.noMobileText &&
    `
      display: none;

      ${mediaQuery('md')} {
        display: flex;
      }
    `}
`;

export const StyledNotificationCountCircle = styled.div`
  background-color: ${({theme}) => theme.colors.primaryT2};
  color: ${({theme}) => theme.colors.primaryW};
  font-weight: ${theme.fontWeight.bold};
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid ${({theme}) => theme.colors.primaryW};
  position: absolute;
  top: -0.375rem;
  left: -0.375rem;
  font-size: var(--h5-font-size);
`;
